export var ApplicantEntity;
(function (ApplicantEntity) {
    ApplicantEntity["Person"] = "PERSON";
    ApplicantEntity["Company"] = "COMPANY";
    ApplicantEntity["Trust"] = "TRUST";
})(ApplicantEntity || (ApplicantEntity = {}));
//# sourceMappingURL=ApplicantEntity.js.map